import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import { StyledChip, StyledChipContainer } from './Chip.styled'

const Chip = ({ className, href, label, onClick, variant }) => {
  if (href) {
    return (
      //  Link Chip
      <StyledChipContainer className={className}>
        <StyledChip>
          <Link to={href}>{label}</Link>
        </StyledChip>
      </StyledChipContainer>
    )
  } else {
    return (
      // Basic & onClick Chip
      <StyledChipContainer className={className} $variant={variant}>
        <StyledChip
          clickable={!!onClick}
          onClick={onClick && onClick}
          $variant={variant}
        >
          {label}
        </StyledChip>
      </StyledChipContainer>
    )
  }
}

Chip.propTypes = {
  className: PropTypes.any,
  href: PropTypes.string,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.string,
}

export default Chip
